import {InjectionToken} from '@angular/core'
import {ConfigurationEmbeddedService} from '@service/configuration/configuration.embedded.service'
import {ConfigurationService} from '@service/configuration/configuration.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `ConfigurationService`.
 *
 * @description
 * Devuelve `ConfigurationEmbeddedService` en modo embebido y
 * `ConfigurationService` en modo standalone. `ConfigurationService`
 * centraliza la configuración dinámica de la aplicación (ajustes por
 * cliente, licencias, workflows) que se leen tras el login.
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `ConfigurationService`.
 */
export function providerConfigurationServiceFactory(embeddedClientService: EmbeddedClientService) {
  return embeddedClientService.isEmbeddedFunction() ? new ConfigurationEmbeddedService() : new ConfigurationService()
}
/**
 * `InjectionToken` que referencia la instancia activa de `ConfigurationService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con
 * {@link providerConfigurationServiceFactory}.
 */
export const ConfigurationServiceToken = new InjectionToken<ConfigurationService>('ConfigurationService')
